import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import type { RuleObject } from 'antd/es/form';

// copied from antd/es/form
type Validator = (_: RuleObject, value: any) => Promise<any>;

const VALID_NAME = /^[\w,\s()-]+\.[A-Za-z]{1,5}$/; // Allows letters, numbers, spaces, hyphens, underscores

export const validateSpecialCharacters: Validator = (_, value) => {
  if (value && !VALID_NAME.test(value)) {
    showNotification({
      message: `'FileName' Special Characters like , [ # % & * : < > ? / ] are not allowed in the file name.`,
      type: NOTIFICATION_TYPES.ERROR,
    });
    return Promise.reject();
  }
  return Promise.resolve();
};
